import { subscribe, unsubscribe } from '@wh/message-bus'; //TODO change to @sb/message-bus once problem fixed with this package deploying and remove ts-ignore
import { MB_ANALYTICS_ADAPTER_READY } from '../consts';
export const whenAdapterReady = (callback) => {
    const token = subscribe(MB_ANALYTICS_ADAPTER_READY, () => {
        callback();
        unsubscribe(token);
    });
};
